
import React from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CircularProgress from '@material-ui/core/CircularProgress';

import { GoogleLogin } from 'react-google-login';

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

import { googleKeys, facebookKeys } from '../../helpers/keys';


const SignUp = (props) => {

    const { handleClose, actions, userManager } = props;

    const [passwordConfrim, passwordConfrim_set] = React.useState("");
    const [email, email_set] = React.useState('');
    const [password, password_set] = React.useState('');
    const [fullName] = React.useState('');
    const [isRegistered, isRegistered_set] = React.useState(false);

    const isRegistering = userManager.loggingIn;

    const canSubmit = password === passwordConfrim && password.length >= 8;

    const isLoggedIn = userManager.user;
    const isLoggingIn = userManager.loggingIn;

    // const isRegistered = userManager.registered;

    return <Dialog
        open={true}
        onClose={() => {
            // viewLogin_set(false);
        }}
        maxWidth={'xs'}
        fullWidth={true}>
        {!isLoggedIn && <DialogTitle>Sign Up</DialogTitle>}
        <DialogContent>

            <div>
                {isLoggedIn && <div>
                    <div style={{ fontSize: 30 }}>
                        You are signed up and logged in!
                </div>
                </div>}
                {isRegistering && <div style={{ textAlign: 'center' }}>
                    <CircularProgress size={68} />
                </div>}
                {isRegistered && !isLoggedIn && <div>
                    <div style={{ fontSize: 24 }}>
                        Registration Complete
                    </div>
                    <div style={{ fontSize: 14, fontFamily: 'roboto', color: '#9199ab', textAlign: 'center', marginTop: 20 }}>
                        <Button variant='outlined' color='primary' style={{ textTransform: 'none' }} onClick={() => {
                            handleClose('login');
                        }}>
                            Log In
                    </Button>
                    </div>
                </div>}
                {!isLoggedIn && !isLoggingIn && <div>

                    {!isRegistering && !isRegistered && <div>

                        {userManager.registerErrorMessage && <div style={{ marginTop: 10 }}>
                            <div style={{ width: '100%' }}>
                                <div style={{
                                    border: '1px solid #ffddd9', backgroundColor: '#ffddd9', borderRadius: 3,
                                    color: '#cc3833', textAlign: 'center', fontSize: 14, paddingTop: 10, paddingBottom: 10
                                }}>
                                    {userManager.registerErrorMessage}
                                </div>
                            </div>
                        </div>}
                        <div style={{ marginTop: 10 }}>
                            {/* <div>Create an Account</div> */}
                            <div style={{ width: '100%' }}>
                                <div style={{
                                    fontFamily: "Roboto",
                                    marginLeft: 2,
                                    fontSize: 14
                                }}>Enter Email</div>
                                <TextField
                                    id="outlined-email"
                                    margin="normal"
                                    variant="outlined"
                                    fullWidth={true}
                                    autoComplete="email"
                                    type="email"
                                    style={{ marginTop: 5 }}
                                    value={email}
                                    onChange={(event) => {
                                        email_set(event.target.value);
                                    }}
                                    inputProps={{
                                        style: {
                                            padding: 10,
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ width: '100%' }}>
                                <div style={{
                                    fontFamily: "Roboto",
                                    marginLeft: 2,
                                    fontSize: 14
                                }}>Enter Password</div>
                                <TextField
                                    id="password"
                                    // placeholder="Password"
                                    margin="normal"
                                    variant="outlined"
                                    type="password"
                                    fullWidth={true}
                                    autoComplete="current-password"
                                    style={{ marginTop: 5 }}
                                    value={password}
                                    onChange={(event) => {
                                        password_set(event.target.value);
                                    }}
                                    inputProps={{
                                        style: {
                                            padding: 10,
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ width: '100%' }}>
                                <div style={{
                                    fontFamily: "Roboto",
                                    marginLeft: 2,
                                    fontSize: 14
                                }}>Confirm Password</div>
                                <TextField
                                    id="passwordConfirm"
                                    // placeholder="Password"
                                    margin="normal"
                                    variant="outlined"
                                    type="password"
                                    fullWidth={true}
                                    autoComplete="current-password"
                                    style={{ marginTop: 5 }}
                                    value={passwordConfrim}
                                    onChange={(event) => {
                                        passwordConfrim_set(event.target.value);
                                    }}
                                    inputProps={{
                                        style: {
                                            padding: 10,
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <Button variant="contained" color="primary" fullWidth={true} onClick={() => {
                                    if (!canSubmit) {
                                        if (password !== passwordConfrim) {
                                            alert("Passwords must match");
                                        }
                                        else {
                                            alert("Password must be at least 8 characters long");
                                        }
                                    }
                                    else {
                                        actions.register(email, fullName, password, () => {
                                            isRegistered_set(true);
                                        });
                                    }
                                }}>Sign Up</Button>
                                {/* <Button variant="contained" color="primary" fullWidth={true} onClick={() => {
                            actions.isLoggedIn(email, fullName, password);
                        }}>Check </Button> */}
                            </div>
                            <div style={{ marginTop: 15, marginBottom: 20, color: '#c5cbd6' }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ height: 13, borderBottom: '1px solid #c5cbd6', width: '100%' }}></div>
                                    <div style={{ paddingLeft: 20, paddingRight: 20, textAlign: 'center' }}>or</div>
                                    <div style={{ height: 13, borderBottom: '1px solid #c5cbd6', width: '100%' }}></div>
                                </div>
                            </div>
                            <GoogleLogin
                                {...googleKeys()}
                                render={renderProps => (
                                    <Button variant="outlined" fullWidth={true} style={{
                                        justifyContent: 'initial', lineHeight: '30px', textTransform: 'none'

                                    }} onClick={renderProps.onClick}>
                                        <svg viewBox="0 0 18 18" id="icon-google-ico" width="20px"><g fill="none" fillRule="evenodd"><path fill="#4285F4" d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"></path><path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"></path></g></svg>
                                        <span style={{ width: '100%' }}>Sign Up with Google</span>
                                    </Button>
                                )}
                                buttonText="Login"
                                onSuccess={(data) => {

                                    actions.loginGoogle(data.tokenId, () => {
                                        isRegistered_set(true);
                                        // handleClose('login');
                                    });
                                }}
                                onFailure={(data) => {
                                    alert('Error');
                                }}
                            />
                            <div style={{ marginTop: 10 }}>
                                <FacebookLogin
                                    {...facebookKeys()}
                                    callback={(response) => {
                                        console.log('success facebook', response);

                                        actions.loginFacebook(response.accessToken, response.signedRequest, () => {
                                            isRegistered_set(true);
                                            // handleClose('login');
                                        });
                                    }}
                                    render={renderProps => {
                                        return <Button variant="outlined" fullWidth={true} style={{
                                            justifyContent: 'initial', lineHeight: '30px', textTransform: 'none'
                                        }} onClick={renderProps.onClick}>
                                            <svg viewBox="0 0 18 18" id="icon-facebook-ico" width="20px"><g fill="none" fillRule="evenodd"><path fill="#4267B2" d="M17.007 0H.993A.993.993 0 0 0 0 .993v16.014c0 .548.445.993.993.993h8.628v-6.961H7.278V8.314H9.62V6.31c0-2.324 1.421-3.59 3.494-3.59.699-.002 1.397.033 2.092.105v2.43h-1.428c-1.13 0-1.35.534-1.35 1.322v1.735h2.7l-.35 2.725h-2.365V18h4.593a.993.993 0 0 0 .993-.993V.993A.993.993 0 0 0 17.007 0z"></path><path fill="#FFF" d="M12.182 18v-6.833h2.37l.354-2.674h-2.724V6.79c0-.774.222-1.298 1.362-1.298H15V3.104A20.657 20.657 0 0 0 12.886 3c-2.094 0-3.522 1.243-3.522 3.525v1.968H7v2.674h2.364V18h2.818z"></path></g></svg>
                                            <span style={{ width: '100%' }}>Sign Up with Facebook</span>
                                        </Button>
                                    }
                                    }
                                />
                            </div>
                            {/* <div style={{ marginTop: 10 }}>
                        <Button variant="outlined" fullWidth={true} style={{
                            justifyContent: 'initial', lineHeight: '30px', textTransform: 'none'
                        }}>
                            <svg viewBox="0 0 18 18" id="icon-facebook-ico" width="20px"><g fill="none" fillRule="evenodd"><path fill="#4267B2" d="M17.007 0H.993A.993.993 0 0 0 0 .993v16.014c0 .548.445.993.993.993h8.628v-6.961H7.278V8.314H9.62V6.31c0-2.324 1.421-3.59 3.494-3.59.699-.002 1.397.033 2.092.105v2.43h-1.428c-1.13 0-1.35.534-1.35 1.322v1.735h2.7l-.35 2.725h-2.365V18h4.593a.993.993 0 0 0 .993-.993V.993A.993.993 0 0 0 17.007 0z"></path><path fill="#FFF" d="M12.182 18v-6.833h2.37l.354-2.674h-2.724V6.79c0-.774.222-1.298 1.362-1.298H15V3.104A20.657 20.657 0 0 0 12.886 3c-2.094 0-3.522 1.243-3.522 3.525v1.968H7v2.674h2.364V18h2.818z"></path></g></svg>
                            <span style={{ width: '100%' }}>Sign Up with Facebook</span>
                        </Button>
                    </div> */}

                            <div style={{ fontSize: 14, fontFamily: 'roboto', color: '#9199ab', textAlign: 'center', marginTop: 20 }}>
                                <span>Already have an account?</span>
                                <span style={{ textDecoration: 'none', color: '#3f51b5', marginLeft: 5, cursor: 'pointer' }} onClick={() => {
                                    handleClose('login');
                                }}>
                                    Log In
                        </span>

                            </div>
                        </div>
                    </div>}
                </div>}
            </div>
        </DialogContent>
        {!isRegistered && <DialogActions>
            <Button onClick={() => {
                handleClose();
            }} color="primary">
                Cancel
            </Button>
        </DialogActions>}
        {isLoggedIn && <DialogActions>
            <Button onClick={() => {
                handleClose();
            }} color="primary">
                Close
            </Button>
        </DialogActions>}
    </Dialog>
}

export default SignUp;


// WEBPACK FOOTER //
// ./src/login/components/SignUpPage.js